var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrazil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 40C31.0455 40 39.9998 31.0457 39.9998 20C39.9998 8.95427 31.0455 -3.05176e-05 19.9998 -3.05176e-05C8.95406 -3.05176e-05 -0.000244141 8.95427 -0.000244141 20C-0.000244141 31.0457 8.95406 40 19.9998 40Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 7.82608L36.5216 20L19.9999 32.1739L3.47815 20L19.9999 7.82608Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 26.9565C23.8419 26.9565 26.9564 23.842 26.9564 20C26.9564 16.1581 23.8419 13.0435 19.9999 13.0435C16.158 13.0435 13.0435 16.1581 13.0435 20C13.0435 23.842 16.158 26.9565 19.9999 26.9565Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5215 19.5652C15.3119 19.5652 14.1444 19.7492 13.0455 20.0906C13.0942 23.8906 16.1883 26.9566 19.9998 26.9566C22.3567 26.9566 24.4383 25.7834 25.6966 23.9903C23.5437 21.2952 20.2312 19.5652 16.5215 19.5652V19.5652Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8275 21.3328C26.9112 20.9013 26.9564 20.456 26.9564 20C26.9564 16.158 23.8419 13.0435 20 13.0435C17.1332 13.0435 14.6723 14.778 13.6073 17.2544C14.5487 17.0593 15.5234 16.9566 16.5218 16.9566C20.5621 16.9565 24.2173 18.636 26.8275 21.3328V21.3328Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazil);
export default __webpack_public_path__ + "static/media/brazil.539f1f7d90ac494c5de7c8be85196650.svg";
export { ForwardRef as ReactComponent };